/*
 * Created by Tigran Yengibaryan
 * Created on 11/06/2021 12:28
 *
 * Copyright (c) 2021 PicsArt.Inc
 */

import { FC } from 'react';
import styled from 'styled-components';

type FooterProps = {
  onBack?: () => void;
  onNext?: () => void;
  nextDisabled?: boolean;
};

const Content = styled.div`
  border: 1px solid #edeef4;
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  height: 80px;
  background: #fff;
`;

const NextButton = styled.button<{ disabled?: boolean }>`
  background: ${props => (props.disabled ? '#DCDDE9' : '#3a76e8')};
  border-radius: 10px;
  text-transform: capitalize;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #fff;
  width: 6.438rem;
  height: 3.5rem;
  transition: background-color ease-in 0.2s;

  &:hover {
    background: ${props => (props.disabled ? '#DCDDE9' : '#386cd0')};
  }
`;

const BackButton = styled.button`
  box-sizing: border-box;
  border-radius: 10px;
  text-transform: capitalize;
  color: #535771;
  width: 6.438rem;
  height: 3.5rem;
  background: #ffffff;
  border: 1px solid #dcdde9;
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  transition: border-color ease-in 0.2s;

  &:hover {
    border-color: #7b8196;
  }
`;

export const Footer: FC<FooterProps> = ({ onBack, onNext, nextDisabled = false }) => {
  return (
    <Content>
      {onBack && <BackButton onClick={onBack}>Back</BackButton>}
      {onNext && (
        <NextButton onClick={onNext} disabled={nextDisabled}>
          Next
        </NextButton>
      )}
    </Content>
  );
};
